import * as React from "react";
import { ERoutes } from "../../../../../AppRouter";
import { Switch, Route } from "react-router";
import { FormateurSuiviListPage } from "./FormateurSuiviListPage";
import { FormateurSuiviItemPage } from "./FormateurSuiviItemPage";
import { FormateurOtherSuiviDetailPage } from "..";

export interface IFormateurSuiviSwitchProps {}

export const FormateurSuiviSwitch: React.FunctionComponent<IFormateurSuiviSwitchProps> = () => {
  return (
    <Switch>
      <Route path={`${ERoutes.formateur}/:id/:tab`} component={FormateurSuiviListPage} exact />
      <Route path={`${ERoutes.formateur}/:id/:tab/pedagogiques/:idSuivi/:state`} component={FormateurSuiviItemPage} />
      <Route path={`${ERoutes.formateur}/:id/:tab/autres/:idSuivi/:state`} component={FormateurOtherSuiviDetailPage} />
    </Switch>
  );
};
